export default __webpack_public_path__ + "static/media/work3.8fdeafd7.jpg";